<template>
	<div class="website-list">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<!-- 通知配置 -->
		<el-dialog :visible.sync="dialogVisable" title="通知设置" close-on-click-modal width="600px">
			<el-form
				:model="editData"
				:rules="rules"
				ref="website"
				class="demo-form-inline"
				label-width="110px"
			>
				<el-row :gutter="20">
					<el-form-item label="客户名称:" :span="12" prop="custName">
						<el-col :span="24">
							<span>{{ editData.custName }}</span>
						</el-col>
					</el-form-item>
					<el-form-item label="订单编号:" prop="webName">
						<el-col :span="24">
							<span>{{ editData.orderCode }}</span>
						</el-col>
					</el-form-item>
					<el-form-item label="邮箱推送:" :span="12" prop="emailFlag">
						<el-col :span="24">
							<el-radio-group v-model="editData.emailFlag">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-col>
					</el-form-item>
					<el-form-item label="推送邮箱:" :span="12" prop="emails" v-if="editData.emailFlag == 1">
						<el-col :span="24">
							<el-input v-model="editData.emails" clearable placeholder="推送人邮箱"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="通知模板:" :span="12" prop="templateType">
						<el-col :span="24">
							<el-radio-group v-model="editData.templateType">
								<el-radio :label="1">标椎版</el-radio>
								<el-radio :label="2">回复版</el-radio>
							</el-radio-group>
						</el-col>
					</el-form-item>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirm">确认</el-button>
				<el-button @click="dialogVisable = false">取消</el-button>
			</div>
		</el-dialog>
		<!-- 询盘邮箱 -->
		<el-dialog
			:visible.sync="emailVisable"
			title="询盘邮箱"
			close-on-click-modal
			@close="dialogClose"
			top="60px"
			width="750px"
		>
			<el-radio-group v-model="emailBindType" class="email-radio">
				<el-radio :label="1">手动绑定</el-radio>
				<el-radio :label="2" :disabled="autoDisabled">自动绑定</el-radio>
			</el-radio-group>
			<form-combination
				v-if="emailBindType == 1"
				:formData="emailFormData"
				@search-click="checkMail"
				ref="enquiryForm"
			></form-combination>
			<div class="email-auto-bind" v-else>
				<!-- 渠道账号选择 -->
				<el-row class="channel_account">
					<el-col :span="4">选择渠道账号：</el-col>
					<el-col :span="10">
						<el-select
							v-model="domainid"
							placeholder="请选择"
							filterable
							remote
							clearable
							:disabled="getChannelAccountDisabled"
							:remote-method="getChannelAccountList"
							@change="channelAccountChange"
						>
							<el-option
								v-for="item in channelAccountList"
								:key="item.id"
								:label="item.domainName"
								:value="item.id"
							>
								<span style="float: left">{{ item.domainName }}</span>
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<div class="email-steps">
					<sky-steps :steps="emailSteps" direction="vertical" :active="emailStepActive"></sky-steps>
				</div>

				<div class="email-auto-form">
					<el-form :model="emailAutoForm" ref="emailAutoForm" size="small" label-width="0px">
						<!-- step1 -->
						<el-form-item label="" class="email-form-doamin">
							<p>
								<span>进入</span>
								<a href="https://qiye.163.com/login" target="_blank" class="mail-link">企业邮箱</a>
								<span>后台添加客户域名</span>
							</p>
							<el-checkbox
								v-model="emailAutoForm.twoDomainFlag"
								:true-label="1"
								:false-label="0"
								:disabled="getTwoDomaionDisabled"
								@change="changeSteps(1)"
								>使用二级域名开通</el-checkbox
							>
							<el-row>
								<el-col :span="7"
									>{{ getEmailAutoFormDoamin ? '客户二级域名' : '客户域名' }}：</el-col
								>
								<el-col :span="15">
									<el-form-item v-if="getEmailAutoFormDoamin">
										<el-input
											v-model="emailAutoForm.twoDomain"
											:disabled="getTwoDomaionDisabled"
											@focus="changeSteps(1)"
										>
											<template slot="append">{{ getSliceCustomDomain }}</template>
										</el-input>
									</el-form-item>
									<el-form-item v-else>
										<el-row>
											<el-col :span="22">
												<el-input
													v-model="customDomain"
													disabled
													@focus="changeSteps(1)"
												></el-input>
											</el-col>
											<el-col :span="2">
												<el-button
													v-clipboard:copy="customDomain"
													v-clipboard:success="copyCustomDomain"
													:type="emailBtnType"
													class="email-suffix-btn"
													>复制</el-button
												>
											</el-col>
										</el-row>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form-item>
						<!-- step2-->
						<el-form-item label="" class="email-form-txt">
							<p>填写获取的TXT值</p>
							<el-row>
								<el-col :span="7">TXT：</el-col>
								<el-col :span="14">
									<el-input
										v-model="emailAutoForm.txtValue"
										:disabled="emailAutoForm.txtFlag == 2"
										@focus="changeSteps(2)"
									></el-input>
								</el-col>
								<el-col :span="2">
									<el-button
										:type="emailBtnType"
										class="email-suffix-btn"
										:loading="analysisLoading"
										:disabled="emailAutoForm.txtFlag == 2"
										@click="analysisTxt"
										>{{ emailAutoForm.txtFlag == 2 ? '已解析' : '解析' }}</el-button
									>
								</el-col>
							</el-row>
						</el-form-item>
						<!-- step3 -->
						<el-form-item label="" class="email-form-default">
							<p>创建默认邮箱</p>
							<div class="email-default-row">
								<p class="row-label">默认企业询盘邮箱：</p>
								<el-input
									class="row-input"
									v-model="emailAutoForm.email"
									:disabled="emailAutoForm.emailFlag == 2"
									@focus="changeSteps(3)"
								>
									<template slot="append">
										@{{
											getEmailAutoFormDoamin
												? `${emailAutoForm.twoDomain}.${getSliceCustomDomain}`
												: getSliceCustomDomain
										}}</template
									>
								</el-input>
								<el-button
									class="row-button"
									:type="emailBtnType"
									:disabled="getTxtid"
									:loading="openingLoading"
									@click="openingMail"
									>{{ emailAutoForm.emailFlag == 2 ? '已开通' : '开通' }}</el-button
								>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" v-if="emailBindType == 2" :loading="noBindLoad" @click="noBind"
					>解绑</el-button
				>
				<el-button type="primary" @click="emailConfirm">确认</el-button>
				<el-button @click="emailVisable = false">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import _ from 'lodash';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import website from '@/backend/services/website/website.js';
import customers from '@/backend/services/account/customer.js';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import listPageCreate from '@/mixins/listPageCreate';
import { onLineStatus, sitePlatform } from '@/common/dictionary';
import { validMobile, validEmail } from '@/common/elementValid';
import customer from '@/mixins/customer';
import jumpLink from '@/components/website/jumpLink';
import skySteps from '@/components/iglobalwin/formComponents/sky-steps';
import vm from '@/common/confirm.js';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';

const list = listPageCreate({
	searchConfig: {
		api: api.website.orderwebsitepage,
		method: 'POST',
	},
});

export default {
	name: 'websiteList',
	components: {
		filterPanel,
		formCombination,
		skySteps,
	},

	mixins: [list, customer, beforeRouteEnter],
	data() {
		const that = this;
		const groups = {
			others: [
				{
					tagName: 'sky-select',
					value: '',
					label: '订单号',
					placeholder: '订单号',
					prop: 'orderId',
					options: [],
					props: {
						label: 'value',
						value: 'id',
					},
					filterable: true,
					remote: true,
					'remote-method'(val) {
						website.getOrderQuery({ name: val }).then(val => {
							that.groups.others[0].options = val.data;
						});
					},
				},
				{
					tagName: 'sky-input',
					placeholder: '订单主域名',
					label: '订单主域名',
					prop: 'domainName',
				},
				{
					label: '上线时间',
					startPlaceholder: '上线开始日期',
					endPlaceholder: '上线结束日期',
					prop: ['beginTimeStr', 'endTimeStr'],
					tagName: 'sky-date-picker',
					type: 'daterange',
					value: [],
				},
			],
			multiples: [
				{
					defaultText: '建站平台',
					placeholder: '建站平台',
					label: '建站平台',
					prop: 'sitePlatform',
					options: sitePlatform,
				},
				{
					defaultText: '状态',
					placeholder: '状态',
					label: '状态',
					prop: 'upLineStatus',
					options: onLineStatus,
				},
				{
					defaultText: 'GA状态',
					placeholder: 'GA状态',
					label: 'GA状态',
					prop: 'monitorFlag',
					options: [
						{ label: '未绑定', value: 1 },
						{ label: '已绑定', value: 2 },
					],
				},
			],
		};
		const column = [
			{
				label: '订单号',
				type: 'custInfo',
				text: [
					{
						bind: 'orderCode',
					},
				],
			},
			{
				label: '客户名称',
				type: 'custInfo',
				text: [
					{
						bind: 'custName',
					},
				],
			},
			{
				label: '语言',
				type: 'custInfo',
				text: [
					{
						bind: 'languageStrs',
					},
				],
			},
			{
				label: '服务人员',
				bind: 'serviceStaffName',
			},
			{
				label: '建站平台',
				bind: 'sitePlatformName',
			},
			{
				label: '上线统计',
				type: 'taskComplete',
				customName: 'none',
				complete: function (row) {
					return `${row.langCount || 0}/${row.langTotal}`;
				},
			},
			{
				label: '上线时间',
				type: 'custInfo',
				minWidth: 130,
				text: [
					{
						bind: 'upLineDateStr',
					},
				],
			},
			{
				label: '订单主域名',
				type: 'custom',
				minWidth: 130,
				componentName: jumpLink,
				bind: 'domainName',
			},
			{
				label: '上线状态',
				bind: 'upLineStatusStr',
			},
			{
				label: 'GA',
				bind: 'gaId',
				type: 'multiRowPopover',
				minWidth: 100,
				dataList(row) {
					if (row.gaId) {
						return [{ value: 'GA ' + row.gaId }];
					} else if (row.siteId) {
						return [{ value: 'BD ' + row.siteId }];
					} else {
						return [];
					}
				},
				dialogList(val, row) {
					if (row.gaId) {
						return [{ value: 'GA ' + row.gaId }];
					} else if (row.siteId) {
						return [{ value: 'BD ' + row.siteId }];
					} else {
						return [];
					}
				},
			},
			{
				label: 'GTM',
				type: 'multiRowPopover',
				bind: 'gtmId',
				minWidth: 100,
				multiRow: true,
				dataList(row) {
					return [
						{
							value: row.gtmId ? row.gtmId : '-',
						},
						{
							value: `已安装 ${row.langCount || 0}/${row.langSum || 0}`,
						},
					];
				},
				dialogList(val, row) {
					let { gtmId, gtmLanguageList } = row;
					let arr = gtmLanguageList.map(item => {
						return {
							label: item.name,
							value: item.gtmStatusName,
						};
					});
					if (gtmId) {
						arr.push({
							label: 'GTM-ID：',
							value: gtmId,
						});
					}
					return arr;
				},
			},
			{
				label: '企业询盘邮箱',
				type: 'custInfo',
				minWidth: 130,
				text: [
					{
						bind: 'inquiryEmail',
					},
				],
			},
			{
				label: '操作',
				type: 'btnClick',
				align: 'center',
				style: 'text',
				width: 230,
				bind: () => {
					return [
						{
							text: '配置',
							showButton() {
								return that.getPermission(that.$permissionData.webSiteConfigure.englishName);
							},
							trigger: row => {
								that.$router.push({
									name: 'website_detail',
									query: {
										orderId: row.orderId,
									},
								});
							},
						},
						{
							text: '通知设置',
							showButton() {
								return that.getPermission(that.$permissionData.websiteMessageSite.englishName);
							},
							trigger(row) {
								that.editData = row;
								that.oldEmail = row.inquiryEmail;
								that.oldPassword = row.emailPassword;
								that.dialogVisable = true;
								that.emailStatus = 1;
							},
						},
						{
							text: '监测绑定',
							showButton() {
								return that.getPermission(that.$permissionData.MonitorBinding.englishName);
							},
							trigger(row) {
								let { upLineStatus, serviceSiteId } = row;
								that.$router.push({
									name: 'MonitoringBinding',
									query: {
										serviceSiteId,
										upLineStatus,
									},
								});
							},
						},
						{
							text: '询盘邮箱',
							showButton() {
								//1已上线
								return (
									// rows.upLineStatus == 1 &&
									that.getPermission(that.$permissionData.inquiryEmail.englishName)
								);
							},
							async trigger(row) {
								if (that.afterServiceSiteId !== row.serviceSiteId) {
									that.domainid = '';
								}
								that.afterServiceSiteId = row.serviceSiteId;
								that.customDomain = row.domainName;
								await that.getInquiryMail(row.serviceSiteId);
								that.emailVisable = true;
							},
						},
					];
				},
			},
		];
		return {
			customDomain: '',
			emailAutoForm: {
				twoDomainFlag: '',
				twoDomain: '',
				email: 'sales',
				txtValue: '',
			},
			autoDisabled: false,
			emailSteps: [{ title: '步骤一' }, { title: '步骤二' }, { title: '步骤三' }],
			groups: groups,
			column: column,
			editData: {
				webName: '',
				custName: '',
				pushPhone: '',
				pushEmail: '',
				inquiryEmail: '',
				emailPassword: '',
				emailFlag: false,
				weixinPushFlag: false,
				smsPushFlag: false,
				templateType: 1,
			},
			rules: {
				pushPhone: [{ validator: validMobile(), trigger: 'blur' }],
				pushEmail: [{ validator: validEmail(), trigger: 'blur' }],
			},
			dialogVisable: false,
			emailVisable: false,
			analysisLoading: false,
			openingLoading: false,
			emailFlag: 0,
			oldEmail: '',
			oldPassword: '',
			emailStatus: 1,
			emailBindType: 0,
			emailFormData: {},
			emailBtnType: 'primary',
			emailStepActive: 1,
			validLoading: false,

			// 渠道账号
			channelAccountList: [],
			domainid: '',
			afterServiceSiteId: '',
			noBindLoad: false,
		};
	},
	filters: {
		sliceMainDomain(val) {
			if (!val) return '';
			return val.toString().split('.').slice(-2).join('.');
		},
	},
	mounted() {
		this.getChannelAccountList();
	},
	computed: {
		getEmailAutoFormDoamin() {
			return this.emailAutoForm.twoDomainFlag == 1;
		},
		getSliceCustomDomain() {
			if (!this.customDomain) return '';
			// let rootDomian = this.customDomain.toString().split('.').slice(-2).join('.');
			let rootDomian = this.customDomain.toString();
			return rootDomian;
		},
		getTxtid() {
			return (
				!this.emailAutoForm.id ||
				this.emailAutoForm.emailFlag == 2 ||
				this.emailAutoForm.txtFlag === 3
			);
		},
		getTwoDomaionDisabled() {
			if (this.emailBindType == 2 && this.emailAutoForm.twoDomainFlag == 1) {
				return this.emailAutoForm.emailFlag == 2;
			}
			return false;
		},
		getChannelAccountDisabled() {
			return this.emailAutoForm.emailFlag === 2;
		},
	},
	watch: {
		emailBindType: {
			handler(val) {
				//如果是自动绑定 email没有值的情况 赋初始值
				if (val == 2 && !this.emailAutoForm.email) {
					this.emailAutoForm.email = 'sales';
				}
				// 获取的默认值是自动  切换到手动绑定时  清除数据
				if (val == 1 && this.emailAutoForm.emailBindType == 2) {
					this.emailAutoForm.email = '';
					this.emailAutoForm.password = '';
					this.setEmailFormData();
				}
				//获取的默认值是手动  切换自动时  清数据
				if (val == 2 && this.emailAutoForm.emailBindType == 1) {
					this.emailAutoForm.email = 'sales';
					this.emailAutoForm.password = '';
					this.setEmailFormData();
				}
			},
			immediate: true,
		},
		'emailAutoForm.twoDomainFlag': {
			handler(val) {
				if (!val) this.emailAutoForm.twoDomain = '';
			},
		},
	},
	methods: {
		changeEmail(val) {
			this.editData.inquiryEmail = val;
		},
		changePassword(val) {
			this.editData.emailPassword = val;
		},
		copyCustomDomain(e) {
			if (e) vm._success('复制成功');
		},
		changeSteps(step) {
			this.emailStepActive = step;
		},
		// 获取渠道账号列表
		async getChannelAccountList(val) {
			try {
				let res = await website.getDomainlist({
					domainName: val || '',
				});
				this.channelAccountList = res.data;
			} catch (e) {
				vm._info('获取渠道账号列表失败');
			}
		},
		// 渠道账号变化
		channelAccountChange(id) {
			let obj = {};
			obj = this.channelAccountList.find(item => {
				return item.id === id;
			});
			if (obj) {
				this.domainid = id;
				// this.customDomain = obj.domainName;
			}
		},
		async getInquiryMail(serviceSiteId) {
			try {
				let _typeof = Object.prototype.toString;
				let res = await website.getInquiryMail({ serviceSiteId });
				this.emailAutoForm = { ...res.data };
				if (_typeof.call(this.emailAutoForm.twoDomainFlag) == '[object Null]') {
					this.emailAutoForm.twoDomainFlag = 0; // Boolean(this.emailAutoForm.twoDomainFlag)
				}
				this.emailBindType = res.data.emailBindType;
				if (this.emailBindType == 2 && !this.emailAutoForm.email) {
					this.emailAutoForm.email = 'sales';
				}

				if (this.emailAutoForm.domainid) {
					this.domainid = this.emailAutoForm.domainid;
					this.channelAccountChange(this.emailAutoForm.domainid);
				}
				//1.新版企业邮箱；2.旧版企业邮箱；3.不使用; 4.新版企业列表
				this.autoDisabled = res.data.qyEmailType != 1 && res.data.qyEmailType != 4;
				this.setEmailFormData();
			} catch (e) {
				vm._info('请求失败');
			}
		},
		async analysisTxt() {
			if (!this.domainid) {
				vm._warn('请先选择渠道账号');
				return;
			}
			if (!this.emailAutoForm.txtValue) {
				vm._warn('请输入TXT文本');
				return;
			}
			try {
				await vm._confirm(`确定解析TXT文本吗？`);
			} catch (e) {
				return;
			}
			try {
				this.analysisLoading = true;
				this.emailAutoForm.emailBindType = this.emailBindType;
				let param = _.cloneDeep(this.emailAutoForm);
				delete param.email;
				delete param.emailFlag;
				delete param.password;
				let res = await website.analysisTxt({
					...param,
					domainid: this.domainid,
				});
				this.emailAutoForm.id = res.data.id;
				this.emailAutoForm.txtFlag = res.data.txtFlag;
				this.analysisLoading = false;
				if (res.data.txtFlag === 3) {
					vm._warn('解析失败');
					return;
				}
				vm._success('解析成功');
			} catch (e) {
				this.analysisLoading = false;
				vm._warn('解析失败');
			}
		},
		cloneAutoFormData() {
			let dataMail = _.cloneDeep(this.emailAutoForm);
			if (dataMail.email) {
				dataMail.emailBindType = 2;
			}
			return dataMail;
		},
		async openingMail() {
			try {
				if (this.emailAutoForm.txtFlag != 2) {
					vm._warn('TXT未解析成功，请检查后再次解析');
					return;
				}
				this.openingLoading = true;
				this.emailFlag = 0;
				let param = this.cloneAutoFormData();
				param.emailBindType = this.emailBindType;
				let res = await website.analysisMail({
					...param,
					domainid: this.domainid,
				});
				if (res.data == 'success') {
					this.openingLoading = false;
					this.emailAutoForm.emailFlag = 2;
					this.emailFlag = 2; //0 未解析 2 成功
					vm._success('邮箱解析成功');
				}
			} catch (e) {
				this.openingLoading = false;
				this.emailFlag = 0;
				vm._warn('邮箱解析失败');
			}
		},
		_foreach(formData) {
			if (!formData) return {};
			let param = {};
			_.forEach(formData, (val, key) => {
				param[key] = val.value;
			});
			return param;
		},
		async checkMail() {
			let param = this._foreach(this.emailFormData);
			this.emailVerifry('enquiryForm', param);
		},
		setEmailFormData() {
			let data = this.emailAutoForm;
			this.emailFormData = {
				email: {
					label: '询盘邮箱账号',
					formType: 'sky-input',
					value: data.email,
					placeholder: '请输入询盘邮箱账号',
					rules: [validEmail()],
				},
				password: {
					label: '询盘邮箱密码',
					formType: 'sky-input',
					value: data.password,
					'show-password': true,
					inputType: 'password',
					placeholder: '请输入询盘邮箱密码',
					showSearch: true,
					searchName: '验证邮箱',
					searchBtnType: 'primary',
					loading: false,
				},
			};
		},
		emailVerifry(formName, editData) {
			let that = this;
			this.$refs[formName].validate(valid => {
				if (!valid) {
					vm._info('请输入正确邮箱格式');
					return false;
				}
				let email, password;
				if (!editData) {
					email = this.editData.inquiryEmail;
					password = this.editData.emailPassword;
					this.validLoading = true;
				} else {
					email = editData.email;
					password = editData.password;
					this.emailFormData.password.loading = true;
				}
				if (!email || !password) {
					if (editData) this.emailFormData.password.loading = false;
					this.validLoading = false;
					vm._info('请输入邮箱或密码');
					return false;
				}
				customers
					.emailvenify({
						mailbox: email,
						password: password,
					})
					.then(val => {
						that.emailStatus = val.data ? 2 : 3;
						if (editData) this.emailFormData.password.loading = false;
						this.validLoading = false;
						val.data ? vm._success('邮箱验证成功') : vm._warn('邮箱验证失败');
					})
					.catch(() => {
						if (editData) this.emailFormData.password.loading = false;
						this.validLoading = false;
					});
			});
		},
		async emailConfirm() {
			let formData;
			if (this.emailBindType == 1) {
				//1 手动  2 自动
				formData = this._foreach(this.emailFormData);
				formData.serviceSiteId = this.emailAutoForm.serviceSiteId;
			} else {
				formData = this.cloneAutoFormData();
				if (this.emailAutoForm.emailFlag != 2) {
					if (this.emailFlag != 2) {
						vm._warn('请先开通邮箱');
						return;
					}
				}
			}
			try {
				formData.emailBindType = this.emailBindType;
				await website.addAnalysisMail({
					...formData,
					domainid: this.domainid,
				});
				this.emailVisable = false;
				vm._success('操作成功');
			} catch (e) {
				vm._info('操作失败');
			}
		},
		confirm() {
			let obj = {
				serviceSiteId: this.editData.serviceSiteId,
				emailFlag: this.editData.emailFlag,
				emails: this.editData.emails,
				templateType: this.editData.templateType,
			};
			website.bindEmail(obj).then(val => {
				if (val.data) {
					this.$message({
						message: '编辑成功',
						type: 'success',
					});
					this.dialogVisable = false;
					this.query();
				} else {
					this.$message({
						message: val.data.msg,
						type: 'error',
					});
				}
			});
		},
		// 解绑操作
		async noBind() {
			this.noBindLoad = true;

			let control = await this.$confirmShow('确认解绑？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			});
			if (control) {
				try {
					let param = this.cloneAutoFormData();

					let { id, serviceSiteId } = param;
					let res = await website.emailUnbind({
						id,
						serviceSiteId,
					});
					if (res.data) {
						this.emailVisable = false;
						this.noBindLoad = false;
					}
				} catch (error) {
					this.noBindLoad = false;
				}
			} else {
				this.noBindLoad = false;
			}
		},
		dialogClose() {
			this.customDomain = '';
			this.getChannelAccountList();
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-item {
	margin-bottom: 15px;
}

.email-radio {
	margin-bottom: 20px;
}
// 询盘邮箱
.email-auto-bind {
	.channel_account {
		line-height: 40px;
		margin-bottom: 10px;

		.el-select {
			display: block;
		}
	}

	.email-steps {
		width: 12%;
		height: 300px;
		float: left;
	}

	.email-auto-form {
		width: auto;
		max-width: 80%;
		float: left;
		margin-left: 30px;

		.email-form-txt {
			margin-bottom: 75px;
		}

		.email-suffix-btn {
			margin-left: 10px;
		}

		.email-default-row {
			display: flex;

			.row-label {
				flex: 0.5;
			}

			.row-input {
				flex: 1;
			}

			.row-button {
				margin-left: 10px;
			}
		}
	}
}
</style>

<style>
.website-list .el-dialog__body {
	overflow: hidden;
}

.mail-link {
	color: #409eff;
}
</style>
